// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_D_6","cls2":"ExportFormatModal-cls2_2KD ExportFormatModal-cls1_D_6"};